import { useCallback, useEffect, useState } from 'react'
import { isEqual } from '@utils'

/* type HookType = <T>(
    allList: T[],
    list: T[],
    setList: (list: T[]) => void,
    keys: (keyof T)[]
) => {
    search: string
    setSearch: (value: string) => void
} */

export const useFilterBySearch = (allList, list, setList, keys) => {
    const [search, setSearch] = useState('')
    const filter = useCallback(
        search => {
            if (!allList || !allList?.length) {
                return []
            }
            
            if (!search) {
                return allList
            }
            
            return allList.filter(item => keys.find(key => `${item[key]}`.toLowerCase().includes(search)))
        },
        [allList, keys],
    )
    
    useEffect(() => {
        if (!allList?.length) {
            return
        }
        
        const filtered = filter(search)
        
        if (list.length === filtered.length || isEqual(list, filtered)) {
            return
        }
        
        setList(filtered)
    }, [search, allList, list, filter, setList])
    
    return {
        search,
        setSearch,
    }
}
